module.exports = __webpack_public_path__ + "static/media/3d-plan_general.b0580d48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general.svg
// module id = 1032
// module chunks = 0